export default "__VITE_ASSET__CPws2gS7__"